let logon_template = 'sign-in.vue';
let background_images = null;
let syslogo = null;
let menu_class = 'el-menu-vertical-demo';
let functions = false;
let enroll = false;

//以下内容需要进行修改或者增加
if (process.env.VUE_APP_API_ORG === 'xjtlu') {
    functions = true;
    enroll = true;
    background_images = [ 'tsi-ad-banner-0.jpg', 'tsi-ad-banner-1.jpg', 'tsi-ad-banner-2.jpg' ];
} else if (process.env.VUE_APP_API_ORG === 'tsied') {
    //logon_template = 'sign-in-tsied.vue'
    functions = true;
    enroll = true;
}

//以上内容进行修改和增加
const signin = process.env.VUE_APP_API_ROOT ? process.env.VUE_APP_API_ROOT : window.location.origin + '/api/v1'
const signin_url = signin.replace('api/v1', 'sign-in')
const host_url = signin.replace('api/v1', '');
// 导出内容
export default {
    //如果设置sso，则不显示登录页面，直接跳转到sso的页面
    sso: process.env.VUE_APP_SSO_LOGIN_REDIRECT,
    sso_out: process.env.VUE_APP_SSO_LOGOUT_REDIRECT,
    //学校的org缩写
    org: process.env.VUE_APP_API_ORG,
    //登录的template
    logon_template: logon_template,
    //oauth的设置
    oauth: process.env.VUE_APP_OAUTH_LOGIN,
    oauth_out: process.env.VUE_APP_OAUTH_LOGOUT,
    oauth_title: process.env.VUE_APP_OAUTH_TITLE,
    oauth_picture: process.env.VUE_APP_OAUTH_PICTURE,
    oauth_helper: process.env.VUE_APP_OAUTH_HELPER,
    //微信的设置
    wx_redirect: process.env.VUE_APP_API_WX_CORP_REDIRECT,
    background_images: background_images,
    //系统的logo
    syslogo: syslogo,
    //系统登录的url
    signin_url: signin_url,
    //系统登录的url
    host_url: host_url,

    no_qrcode: process.env.VUE_APP_NO_QRCODE,
    no_indicate: process.env.VUE_APP_NO_INDICATE,
    build_time: process.env.VUE_APP_BUILD_TIME,
    //menu
    menu_class: menu_class,
    //sign-in-functions
    sign_in_functions:functions,
    //allow_enroll
    allow_enroll:enroll,
    //env
    prefix:process.env.NODE_ENV === 'production'?'/admin':''
}
